import {
  USER_PROFILE_ACTION_TYPES,
  DELETE_USER_ACTION_TYPES,
  UNDELETE_USER_ACTION_TYPES,
  USER_DELETE_DIALOG_ACTION_TYPES,
  APPROVE_PARENT_USER_ACTION_TYPES,
  REJECT_PARENT_USER_ACTION_TYPES,
  RESEND_INVITE_ACTION_TYPES,
  USER_UPDATE_ACTION_TYPES,
  EDIT_DIALOG_ACTIONS,
  UNDELETE_SET_USER,
  UNDELETE_CLEAR_USER,
  CONFIRM_PARENT_USER_ACTION_TYPES,
} from 'utils/actions/user'
import { userTypeBooleans } from 'utils/userTypes'

const {
  USER_PROFILE_FAILURE,
  USER_PROFILE_REQUEST,
  USER_PROFILE_SUCCESS,
} = USER_PROFILE_ACTION_TYPES
const { DELETE_USER_FAILURE, DELETE_USER_REQUEST, DELETE_USER_SUCCESS } = DELETE_USER_ACTION_TYPES
const {
  UNDELETE_USER_FAILURE,
  UNDELETE_USER_REQUEST,
  UNDELETE_USER_SUCCESS,
} = UNDELETE_USER_ACTION_TYPES
const {
  CONFIRM_PARENT_USER_FAILURE,
  CONFIRM_PARENT_USER_REQUEST,
  CONFIRM_PARENT_USER_SUCCESS,
} = CONFIRM_PARENT_USER_ACTION_TYPES
const { HIDE_USER_DELETE_DIALOG, SHOW_USER_DELETE_DIALOG } = USER_DELETE_DIALOG_ACTION_TYPES

const { USER_UPDATE_FAILURE, USER_UPDATE_REQUEST, USER_UPDATE_SUCCESS } = USER_UPDATE_ACTION_TYPES

const { CLOSE_DIALOG, OPEN_DIALOG } = EDIT_DIALOG_ACTIONS

const defaultState = {
  fetching: true,
  error: null,
  userProfileDetails: null,
  showDeleteDialogForUserId: null,
  deleting: false,
  deleteError: null,
  undeleted: {
    id: null,
    loading: false,
    error: '',
  },
  actionInProgress: false,
  updating: false,
  updateError: null,
  dialogOpen: false,
}

const userProfileReducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case USER_PROFILE_REQUEST:
      return {
        ...state,
        fetching: true,
        error: null,
      }

    case USER_PROFILE_SUCCESS: {
      const {
        payload: { parentUser, user },
      } = action
      let userProfileDetails
      let userType

      if (user) {
        const { userType: tempUserType } = user
        userProfileDetails = user
        userType = tempUserType
      }

      if (parentUser) {
        const { userType: tempUserType } = parentUser
        userProfileDetails = parentUser
        userType = tempUserType
      }

      return {
        ...state,
        fetching: false,
        error: null,
        userProfileDetails,
        ...userTypeBooleans(userType),
      }
    }

    case USER_PROFILE_FAILURE: {
      const { error } = action
      return {
        ...state,
        fetching: false,
        error,
      }
    }

    case SHOW_USER_DELETE_DIALOG: {
      return {
        ...state,
        showDeleteDialogForUserId: action.payload.userId,
      }
    }

    case HIDE_USER_DELETE_DIALOG: {
      return {
        ...state,
        showDeleteDialogForUserId: null,
      }
    }

    case CONFIRM_PARENT_USER_REQUEST: {
      return {
        ...state,
        fetching: true,
        error: null,
      }
    }

    case CONFIRM_PARENT_USER_SUCCESS: {
      const {
        payload: { parentUser },
      } = action

      return {
        ...state,
        fetching: false,
        error: null,
        userProfileDetails: parentUser,
      }
    }

    case CONFIRM_PARENT_USER_FAILURE: {
      const { error } = action
      return {
        ...state,
        fetching: false,
        error,
      }
    }

    case DELETE_USER_REQUEST: {
      return {
        ...state,
        deleting: true,
        deleteError: null,
      }
    }

    case DELETE_USER_SUCCESS: {
      return {
        ...state,
        deleting: false,
        showDeleteDialogForUserId: null,
        userProfileDetails: {
          ...state.userProfileDetails,
          stateName: 'Deleted',
        },
      }
    }

    case DELETE_USER_FAILURE: {
      return {
        ...state,
        deleting: false,
        deleteError: action.error,
      }
    }

    case UNDELETE_SET_USER: {
      return {
        ...state,
        undeleted: {
          ...defaultState.undeleted,
          id: action.payload,
        },
      }
    }

    case UNDELETE_USER_REQUEST: {
      return {
        ...state,
        undeleted: {
          ...state.undeleted,
          loading: true,
        },
      }
    }

    case UNDELETE_USER_SUCCESS: {
      return {
        ...state,
        userProfileDetails: {
          ...state.userProfileDetails,
          stateName: '',
        },
        undeleted: {
          ...state.undeleted,
          loading: false,
          success: true,
        },
      }
    }

    case UNDELETE_USER_FAILURE: {
      return {
        ...state,
        undeleted: {
          ...state.undeleted,
          loading: false,
          success: false,
          error: action.error,
        },
      }
    }

    case UNDELETE_CLEAR_USER: {
      return {
        ...state,
        undeleted: {
          ...defaultState.undeleted,
        },
      }
    }

    case OPEN_DIALOG: {
      return {
        ...state,
        dialogOpen: true,
      }
    }

    case CLOSE_DIALOG: {
      return {
        ...state,
        dialogOpen: false,
      }
    }

    case USER_UPDATE_REQUEST: {
      return {
        ...state,
        updating: true,
        updateError: null,
      }
    }

    case USER_UPDATE_SUCCESS: {
      const {
        payload: { parentUser, user },
      } = action
      const userProfileDetails = user || parentUser

      return {
        ...state,
        userProfileDetails,
        updating: false,
        updateError: null,
        dialogOpen: false,
      }
    }

    case USER_UPDATE_FAILURE: {
      return {
        ...state,
        updating: false,
        updateError: action.error,
      }
    }

    case RESEND_INVITE_ACTION_TYPES.RESEND_INVITE_REQUEST:
    case APPROVE_PARENT_USER_ACTION_TYPES.APPROVE_PARENT_USER_REQUEST:
    case REJECT_PARENT_USER_ACTION_TYPES.REJECT_PARENT_USER_REQUEST: {
      return {
        ...state,
        actionInProgress: true,
      }
    }

    case RESEND_INVITE_ACTION_TYPES.RESEND_INVITE_SUCCESS:
    case RESEND_INVITE_ACTION_TYPES.RESEND_INVITE_FAILURE:
    case APPROVE_PARENT_USER_ACTION_TYPES.APPROVE_PARENT_USER_FAILURE:
    case REJECT_PARENT_USER_ACTION_TYPES.REJECT_PARENT_USER_FAILURE: {
      return {
        ...state,
        actionInProgress: false,
      }
    }

    case APPROVE_PARENT_USER_ACTION_TYPES.APPROVE_PARENT_USER_SUCCESS:
    case REJECT_PARENT_USER_ACTION_TYPES.REJECT_PARENT_USER_SUCCESS: {
      return {
        ...state,
        userProfileDetails: action.payload.parentUser,
        actionInProgress: false,
      }
    }

    default:
      return state
  }
}

export default userProfileReducer
